import { useAuthSelector, useIsLoggedIn } from "@nf/common";

export const useIsAuthenticated = () => {
  const { user, isChild } = useAuthSelector();
  const isLoggedIn = useIsLoggedIn();
  const isRegisteredViaCampaign = user?.UtmCampaign === "aeldresagen";

  return {
    isLoggedIn,
    isChild,
    isRegisteredViaCampaign,
  };
};
